// src/pages/Products/ProductFormModal.tsx
import { useEffect } from "react";
import { Form, Tabs } from "antd";
import WrappingModal from "components/Modals/WrappingModal";

import { useGetColorsQuery } from "../../../redux/Service/colors";
import { useGetMeaguresQuery } from "../../../redux/Service/meaguresApi";
import { useGetStoresQuery } from "../../../redux/Service/storesApi";
import { useGetAccountsQuery } from "../../../redux/Service/Accounts";
import { useGetCostCentersQuery } from "../../../redux/Service/costCenter";
import { useGetVendorsQuery } from "../../../redux/Service/vendorsApi";

import BasicDataTab from "./BasicDataTab";
import PriceAndUnitsTab from "./PriceAndUnitsTab";
import { useGetCategoriesQuery } from "../../../redux/Service/categoryApi";
import { useGetCountriesQuery } from "../../../redux/Service/countriesApi";
import { useGetUnitsQuery } from "../../../redux/Service/units";

const { TabPane } = Tabs;

interface Props {
  form: any;
  isEditing: boolean;
  isModalOpen: boolean;
  handleOk: (values: any) => void;
  handleCancel: () => void;
  initialValues?: any;
  loading: boolean;
}

const FormModal: React.FC<Props> = ({
  form,
  isEditing,
  isModalOpen,
  handleOk,
  handleCancel,
  initialValues,
  loading,
}) => {
  // fetch select options
  const { data: colorsData } = useGetColorsQuery(undefined);
  const { data: measuresData } = useGetMeaguresQuery(undefined);
  const { data: storesData } = useGetStoresQuery(undefined);
  const { data: accountsData } = useGetAccountsQuery(undefined);
  const { data: costsData } = useGetCostCentersQuery(undefined);
  const { data: vendorsData } = useGetVendorsQuery(undefined);
  const { data: categoriesData } = useGetCategoriesQuery(undefined);
  const { data: countriesData } = useGetCountriesQuery(undefined);
  const { data: unitsData } = useGetUnitsQuery(undefined);

  const colorOptions = (colorsData?.ResponseObject || []).map((c: any) => ({
    label: c.ColorName,
    value: c.ColorID,
  }));
  const measureOptions = (measuresData?.ResponseObject || []).map((m: any) => ({
    label: m.MeagureName,
    value: m.MeagureID,
  }));
  const storeOptions = (storesData?.ResponseObject || []).map((s: any) => ({
    label: s.StoreName,
    value: s.StoreID,
  }));
  const accountOptions = (accountsData?.ResponseObject || []).map((a: any) => ({
    label: a.AccName,
    value: a.Id,
  }));
  const costOptions = (costsData?.ResponseObject || []).map((c: any) => ({
    label: c.CostName,
    value: c.Id,
  }));
  const vendorOptions = (vendorsData?.ResponseObject || []).map((v: any) => ({
    label: v.VendorName,
    value: v.VendorID,
  }));
  const categoriesOptions = (categoriesData?.ResponseObject || []).map(
    (v: any) => ({
      label: v.CategoryName,
      value: v.CategoryID,
    })
  );
  const countryOptions = (countriesData?.ResponseObject || []).map(
    (v: any) => ({
      label: v.CountryName,
      value: v.CountryID,
    })
  );
  const unitsOptions = (unitsData?.ResponseObject || []).map((v: any) => ({
    label: v.UnitName,
    value: v.UnitID,
  }));

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [initialValues, form]);

  return (
    <WrappingModal
      title={isEditing ? "تعديل منتج" : "إضافة منتج"}
      form={form}
      handleCancel={handleCancel}
      loading={loading}
      isModalOpen={isModalOpen}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleOk}
        className="space-y-4"
      >
        <Tabs defaultActiveKey="1">
          <TabPane tab="البيانات الأساسية" key="1" className="px-4">
            <BasicDataTab
              form={form}
              isEditing={isEditing}
              accountOptions={accountOptions}
              storeOptions={storeOptions}
              categoriesOptions={categoriesOptions}
              countryOptions={countryOptions}
            />
          </TabPane>

          <TabPane tab="شرائح الأسعار ووحدات إضافية" key="2">
            <PriceAndUnitsTab
              unitsOptions={unitsOptions}
              colorOptions={colorOptions}
              measureOptions={measureOptions}
              costOptions={costOptions}
              vendorOptions={vendorOptions}
            />
          </TabPane>
        </Tabs>
      </Form>
    </WrappingModal>
  );
};

export default FormModal;
